<template>
  <div
    class="nexus_container"
    :class="{
      enabled: workflow.nexusFolderCreationEnabled,
    }"
  >
    <div class="header_section">
      <div class="h_title" v-text="$t('nexus.configuration.title')" />
      <BaseButton
        icon="$mdiCog"
        class="h_action"
        @click="configurationDialogOpened = true"
      >
        <span v-text="$t('nexus.configuration.action')" />
      </BaseButton>
    </div>
    <div class="message" v-text="message" />
    <div class="body_section">
      <div class="nexus_folder">
        <div class="info_section">
          <div class="item_content">
            <span class="item_key" v-text="`${$t('utils.folder')} : `" />
            <span class="item_value" v-text="folderLabel" />
          </div>
          <div class="item_content">
            <span class="item_key" v-text="`${$tc('utils.action', 2)} : `" />
            <span class="item_value" v-text="actionLabel" />
          </div>
          <div class="item_content">
            <span class="item_key" v-text="`${$t('utils.collaborator')} : `" />
            <span class="item_value" v-text="collaboratorLabel" />
          </div>
        </div>
        <v-btn-toggle
          v-if="isConfigured"
          :value="workflow.nexusFolderCreationEnabled"
          small
          class="btn_toggle"
          mandatory
          @change="handleFolderEnableChange($event)"
        >
          <v-btn small :value="true">
            <span class="btn_label" v-text="$t('utils.enabled')" />
            <v-icon class="btn_icon" small right>$mdiFolderPlusOutline</v-icon>
          </v-btn>

          <v-btn small :value="false">
            <span class="btn_label" v-text="$t('utils.disabled')" />
            <v-icon class="btn_icon" small right
              >$mdiFolderRemoveOutline</v-icon
            >
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <WorkflowNexusConfigurationDialog
      v-if="configurationDialogOpened"
      :organization-id="organizationId"
      :workflow="workflow"
      @workflowUpdated="handleWorkflowUpdated"
      @close="configurationDialogOpened = false"
    />
  </div>
</template>
<script>
import { patchOrganizationWorkflow } from "@/modules/Admin/Services/workflow.service";
import WorkflowNexusConfigurationDialog from "./WorkflowNexusConfigurationDialog.vue";
export default {
  name: "WorkflowNexusConfiguration",
  components: {
    WorkflowNexusConfigurationDialog,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      configurationDialogOpened: false,
    };
  },
  computed: {
    isConfigured() {
      return (
        this.workflow.nexusFolderCreateButtonLabel &&
        this.workflow.nexusFolderNameInputLabel
      );
    },
    message() {
      return this.workflow.nexusFolderCreationEnabled
        ? this.$t("nexus.configuration.enable_message")
        : this.$t("nexus.configuration.message");
    },
    folderLabel() {
      return this.workflow.nexusFolderNameInputLabel
        ? this.workflow.nexusFolderNameInputLabel
        : "--";
    },
    actionLabel() {
      return this.workflow.nexusFolderCreateButtonLabel
        ? this.workflow.nexusFolderCreateButtonLabel
        : "--";
    },
    collaboratorLabel() {
      return this.workflow.nexusFolderAssignedCollaborator
        ? this.workflow.nexusFolderAssignedCollaborator.email
        : "--";
    },
  },
  methods: {
    async handleFolderEnableChange(value) {
      try {
        const res = await patchOrganizationWorkflow(
          this.organizationId,
          this.workflow.id,
          {
            nexus_folder_creation_enabled: value,
          }
        );
        this.$emit("workflowUpdated", {
          ...this.workflow,
          ...res.data,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.snackbar.success.workflowModifiedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("workflow.snackbar.success.errorModifyingWorkflow"),
          type: "ERROR",
        });
      }
    },
    handleWorkflowUpdated(workflow) {
      this.$emit("workflowUpdated", workflow);
    },
  },
};
</script>
<style lang="scss">
.nexus_container {
  border-left: 5px solid #ff5267;
  padding: 24px;
  background: #fafdff;
  margin-bottom: 24px;

  .header_section {
    display: flex;
    gap: 8px;
    .h_title {
      display: flex;
      align-items: center;
      flex: 1;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
    }
    .h_action {
      flex: none;
    }
  }
  .message {
    color: #353542;
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
  }
  .nexus_folder {
    margin-top: 8px;
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background: rgba(#ff5267, 0.1);
    gap: 16px;
    transform: all 0.25s;
    .info_section {
      font-size: 14px;
      line-height: 20px;
      color: #353542;
      flex: 1;
      .item_content {
        font-family: "Inter";
        font-size: 14px;
        line-height: 24px;
        .item_key {
          font-weight: 600;
          color: #707080;
        }
        .item_value {
          font-weight: 400;
          color: #707080;
        }
      }
    }
    .btn_toggle {
      flex: none;
      .btn_label {
        font-family: Inter;
        font-size: 12px;
        color: #353542;
      }
      .btn_icon {
        color: #353542;
        ::v-deep {
          .v-icon {
            width: 14px;
            height: 14px;
            color: #353542;
          }
        }
      }
    }
  }
  &.enabled {
    border-color: #427aa1;
    .nexus_folder {
      background: #e6eff4;
    }
  }
}
</style>
